import { useSelector } from "react-redux"
import { StoreType } from "client/store"
import {
    PermissionType,
    AccountPermissionItem,
    ProjectPermissionItem,
    CommonPermissionItem,
    CommonPermissions,
} from "client/store/utils"

export function hasAccess(
    permissionId: string,
    type: PermissionType,
) {
    const { userId, accountId } = useSelector((state: StoreType) => state.system.userData)
    const userGroups = useSelector((state: StoreType) => state.system.userGroups)
    const permissions = useSelector((state: StoreType) => state.system.accountPermissions)

    let access = false
    if (accountId === 1) access = true
    else if (permissions && permissions[permissionId] && permissions[permissionId][type]) {
        const permission = permissions[permissionId][type] as AccountPermissionItem

        if (permission.users && permission.users.includes(userId)) access = true
        userGroups.forEach((groupId) => {
            if (permission.groups && permission.groups.includes(groupId)) access = true
        })
    }
    return access
}

export function hasProjectAccess(
    permissionId: string,
    type: PermissionType,
    projectId?: number,
) {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const targetProjectId = projectId || (project && project.id)

    const { userId } = useSelector((state: StoreType) => state.system.userData)
    const accountUserGroups = useSelector((state: StoreType) => state.system.userGroups)
    const projectUserGroups = useSelector((state: StoreType) => state.system.projectUserGroups)
    const permissions = useSelector((state: StoreType) => state.system.projectPermissions)

    let access = false
    if (project && project.owner === userId) access = true
    if (
        permissions
        && permissions[targetProjectId]
        && permissions[targetProjectId][permissionId]
        && permissions[targetProjectId][permissionId][type]
    ) {
        const permission = permissions[targetProjectId][permissionId][type] as ProjectPermissionItem

        if (permission.users && permission.users.includes(userId)) access = true
        if (accountUserGroups) {
            accountUserGroups.forEach((groupId) => {
                if (permission.accountGroups && permission.accountGroups.includes(groupId)) access = true
            })
        }
        if (projectUserGroups && projectUserGroups[targetProjectId]) {
            projectUserGroups[targetProjectId].forEach((groupId) => {
                if (permission.projectGroups && permission.projectGroups.includes(groupId)) access = true
            })
        }
    }
    return access
}

function hasCommonAccess(
    permissions: CommonPermissions,
    permissionId: string,
    type: PermissionType,
    projectId?: number,
) {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const targetProjectId = projectId || (project && project.id)

    const { userId } = useSelector((state: StoreType) => state.system.userData)
    const accountUserGroups = useSelector((state: StoreType) => state.system.userGroups)
    const projectUserGroups = useSelector((state: StoreType) => state.system.projectUserGroups)

    let access = false
    if (permissions && permissions[permissionId] && permissions[permissionId][type]) {
        const permission = permissions[permissionId][type] as CommonPermissionItem

        if (permission.users && permission.users.includes(userId)) access = true
        if (accountUserGroups) {
            accountUserGroups.forEach((groupId) => {
                if (permission.accountGroups && permission.accountGroups.includes(groupId)) access = true
            })
        }
        if (projectUserGroups && projectUserGroups[targetProjectId]) {
            projectUserGroups[targetProjectId].forEach((groupId) => {
                if (permission.projectGroups && permission.projectGroups.includes(groupId)) access = true
            })
        }
    }
    return access
}

export function hasLifecycleAccess(
    permissionId: string,
    type: PermissionType,
) {
    const permissions = useSelector((state: StoreType) => state.system.lifecyclePermissions)
    return hasCommonAccess(permissions, permissionId, type)
}
